const routes = {
    '/': 'Home',
    '/dashboard': 'Dashboard',

    '/charts': 'Charts',

    '/ensureloggedin': 'EnsureLoggedIn',
    '/ensureloggedin/ensureloggedincontainer': 'EnsureLoggedInContainer',

    '/islands': 'AllIslands',
    '/islands/addisland': 'AddUpdateIsland',
    '/islands/addisland/:id': 'AddUpdateIsland',
    '/islands/exclusivefeatures': 'ExclusiveFeatures',

    '/enquirydetails': 'EnquiryDetails',

    '/categories': 'AllCategories',
    '/categories/addcategory': 'AddCategory',
    '/categories/addcategory/:id': 'AddCategory',

    '/hautemngt': 'HauteManagement',
    '/hautemngt/homepage': 'Homepage',
    '/hautemngt/socialmanagement': 'SocialManagement',

    '/islands/comingsoon': 'ComingSoon',

    '/testpage': 'TestPage'
};
export default routes;



// WEBPACK FOOTER //
// ./src/routes.js